import { globalTheme, useMixin } from '@clds/component-theme';
import { StyledSvg } from './StyledSvg';

export const GaugeIcon = () => {
  return (
    <StyledSvg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.14349 6.78901C8.48139 3.61706 13.5538 3.13444 17.43 5.62L15.58 6.85C12.4219 5.27021 8.60157 5.94784 6.17948 8.51743C3.75738 11.087 3.3065 14.9407 5.07 18H18.93C20.2723 15.6708 20.3549 12.8231 19.15 10.42L20.38 8.57L20.39 8.56C22.4343 11.7129 22.5386 15.7457 20.66 19C20.3013 19.6213 19.6374 20.0028 18.92 20H5.07C4.35978 19.9957 3.7051 19.6151 3.35 19C1.06516 15.0022 1.80559 9.96097 5.14349 6.78901ZM19.08 6.92L13.42 15.41C13.0449 15.7856 12.5358 15.9966 12.005 15.9966C11.4742 15.9966 10.9651 15.7856 10.59 15.41C10.2144 15.0349 10.0034 14.5258 10.0034 13.995C10.0034 13.4642 10.2144 12.9551 10.59 12.58L19.08 6.92Z"
        fill={useMixin(globalTheme.palette.contrastLow)}
      />
    </StyledSvg>
  );
};
